export default function LiquidityFooter(props) {
  return <div className="liquidity-footer">{props.children}</div>;
}
